import { isNullOrWhitespace } from '@mt-ng2/common-functions';

function formatAddress(addr) {
    var _a, _b;
    let isInternational = addr.CountryCode !== 'US';
    let fullAddress = '';
    fullAddress += (_a = addr === null || addr === void 0 ? void 0 : addr.Address1) !== null && _a !== void 0 ? _a : '';
    fullAddress += (addr === null || addr === void 0 ? void 0 : addr.Address2) ? ' ' + addr.Address2 : '';
    fullAddress += (addr === null || addr === void 0 ? void 0 : addr.City) ? ', ' + addr.City : '';
    if (isInternational) {
        fullAddress += (addr === null || addr === void 0 ? void 0 : addr.Province) ? ', ' + addr.Province : '';
        fullAddress += ((_b = addr === null || addr === void 0 ? void 0 : addr.Country) === null || _b === void 0 ? void 0 : _b.Alpha3Code) ? ', ' + addr.Country.Alpha3Code : '';
    }
    else {
        fullAddress += (addr === null || addr === void 0 ? void 0 : addr.StateCode) ? ', ' + addr.StateCode : '';
    }
    fullAddress += (addr === null || addr === void 0 ? void 0 : addr.Zip) ? ' ' + addr.Zip : '';
    return fullAddress;
}
function formatAddressVertical(addr) {
    var _a, _b;
    let isInternational = addr.CountryCode !== 'US';
    let fullAddress = '';
    fullAddress += (_a = addr === null || addr === void 0 ? void 0 : addr.Address1) !== null && _a !== void 0 ? _a : '';
    fullAddress += (addr === null || addr === void 0 ? void 0 : addr.Address2) ? '<br>' + addr.Address2 : '';
    fullAddress += (addr === null || addr === void 0 ? void 0 : addr.City) ? '<br> ' + addr.City : '';
    if (isInternational) {
        fullAddress += (addr === null || addr === void 0 ? void 0 : addr.Province) ? ', ' + addr.Province : '';
        fullAddress += ((_b = addr === null || addr === void 0 ? void 0 : addr.Country) === null || _b === void 0 ? void 0 : _b.Alpha3Code) ? ', ' + addr.Country.Alpha3Code : '';
    }
    else {
        fullAddress += (addr === null || addr === void 0 ? void 0 : addr.StateCode) ? ', ' + addr.StateCode : '';
    }
    fullAddress += (addr === null || addr === void 0 ? void 0 : addr.Zip) ? '  ' + addr.Zip : '';
    return fullAddress;
}

function getFontAwesomeFileImage(filename) {
    let ext = filename.substring(filename.indexOf('.')).substring(1).toLowerCase();
    switch (ext) {
        case 'png':
        case 'jpeg':
        case 'gif':
        case 'jpg':
            return 'fa-file-image-o';
        default:
            return 'fa-file-text-o';
    }
}

function formatPercent(input) {
    const parts = input.split('.');
    const precision = parts.length === 2 ? Math.max(parts[1].length - 2, 0) : 0;
    const factor = Math.pow(10, precision);
    const number = Math.round(parseFloat(input) * 100 * factor) / factor;
    return number;
}

function formatPhone(num) {
    let formatted = '';
    if (isNullOrWhitespace(num)) {
        return formatted;
    }
    let chunks = num.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    formatted = !chunks[2] ? chunks[1] : '(' + chunks[1] + ') ' + chunks[2] + (chunks[3] ? '-' + chunks[3] : '');
    return formatted;
}
function formatPhoneWithExt(num, ext) {
    let extension = '';
    if (ext) {
        extension = 'Ext ' + ext;
    }
    let formattedPhone = formatPhone(num);
    return formattedPhone + ' ' + extension;
}

const format = {
    /**
     * Takes an address object and converts it to a human friendly full address
     * @param addr the address object you would like to format
     */
    address: formatAddress,
    /**
     * Takes an address object and converts it to a human friendly full address
     * Note this does include html so it will need to be put on an innerHtml property.
     * @param addr the address object you would like to format
     */
    addressVertical: formatAddressVertical,
    /**
     * Takes in a file name and returns a font awesome icon for it.  It determines
     * this based on the ext.  This is primarily used when needing to flush a file
     * for example in a list
     * @param filename the file name to be evaluated.
     */
    getFontAwesomeFileImage: getFontAwesomeFileImage,
    /**
     * Handles formatting a javascript number to the properly rounded percentage value
     * If you just multiply it by 100 it will not handle floating points.  We use
     * @example
     * // returns 3.6999999999999997
     * 0.037 * 100
     * @example
     * // returns 3.7
     * formatPercent('0.037')
     * @param input string to be formatted to a percentage.  We use string to easily split on the decimal
     */
    percent: formatPercent,
    /**
     * Takes a string of an unformatted phone number and converts it
     * to a human friendly view
     * @param num the phone you would like to format.  Eg. 8565551234
     */
    phone: formatPhone,
    /**
     * Takes a string of an unformatted phone number and extension and converts it
     * to a human friendly view
     * @param num the phone you would like to format.  Eg. 8565551234
     * @param ext the ext you would like to attach to the phone
     */
    phoneWithExt: formatPhoneWithExt,
};

/**
 * Generated bundle index. Do not edit.
 */

export { format, formatAddress, formatAddressVertical, formatPercent, formatPhone, formatPhoneWithExt, getFontAwesomeFileImage };

//# sourceMappingURL=mt-ng2-format-functions.js.map